import { Account } from "../../pages/account/account";

export class Authentication {
    accessToken: string;
    refreshToken: string;
    account: Account;
    tokenId: string;

    constructor(obj?: any) {
      const ar = obj || {};
  
      Object.assign(this, ar);
      this.account = obj.account ? new Account(obj.account) : null;
    }
  }
  